import { atom } from 'jotai';

// Initialize from localStorage or use empty array
const initialLateStarters = JSON.parse(localStorage.getItem('lateStarters')) || {};

export const lateStartersAtom = atom(
  initialLateStarters,
  (get, set, update) => {
    // If update is a function, call it with the current value
    const nextValue = typeof update === 'function' 
      ? update(get(lateStartersAtom))
      : update;
    
    // Save to localStorage
    localStorage.setItem('lateStarters', JSON.stringify(nextValue));
    
    // Update the atom value
    set(lateStartersAtom, nextValue);
  }
);
